import { EmailValidator } from "@/utils/validators";
import * as Yup from "yup";

export const ValidationSchema = Yup.object({
  email: EmailValidator.required("VALIDATION.REQUIRED")
});
